<div class="p-4 pt-0">
    <div class="flex flex-wrap justify-between items-center gap-4">
        <div class="p-card-title">Original Registrations</div>
        <p-multiSelect 
            [options]="yearOptions" 
            [ngModel]="selectedYearsValue()"
            (ngModelChange)="onYearSelectionChange($event)"
            [showClear]="true"
            [showHeader]="false"
            placeholder="Select Years"
            styleClass="w-auto">
        </p-multiSelect>
    </div>
    
    <!-- Loading Skeleton -->
    <div *ngIf="isLoading()" class="chart-container md:h-[480px] flex items-center justify-center">
        <div class="flex flex-col items-center gap-3">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
            <p class="text-gray-500 text-sm">Loading chart...</p>
        </div>
    </div>
    
           <!-- Chart Content -->
       <div *ngIf="!isLoading()" class="chart-container md:h-[480px]">
            <canvas baseChart
                [data]="chartData()"
                [options]="chartOptions"
                type="line">
            </canvas>
        </div>
</div>